var _defs, _path, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22, _g23, _g24, _g25;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcosinline = function SvgIcosinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icos_inline_svg__Layer_9_copy",
    "data-name": "Layer 9 copy",
    viewBox: "0 0 570.904 129.777"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "icos_inline_svg__defs1"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style1"
  }, ".icos_inline_svg__cls-1{fill:#fff}.icos_inline_svg__cls-2{fill:#6ed3b6}.icos_inline_svg__cls-4{fill:#518dc4}.icos_inline_svg__cls-5{fill:#1b3a7d}"))), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path1",
    d: "M158.016 109.89v-13.2h14.053V35.083h-14.053V21.879h41.072v13.203h-14.05v61.606h14.05l10.753 13.2h-51.825zm88.739 0c-5.909-.167-11.225-1.402-15.941-3.707a37.835 37.835 0 0 1-12.215-9.43c-3.423-3.981-6.053-8.614-7.89-13.892-1.839-5.281-2.756-10.938-2.756-16.973 0-6.035.917-11.692 2.755-16.973 1.838-5.281 4.468-9.911 7.89-13.892a38.587 38.587 0 0 1 12.216-9.492c4.719-2.346 10.032-3.562 15.941-3.646h10.702v13.203H247.08c-3.82.084-7.314.903-10.483 2.451-3.172 1.552-5.927 3.708-8.27 6.476-2.342 2.765-4.16 6.014-5.457 9.743-1.297 3.73-1.945 7.776-1.945 12.133 0 4.356.648 8.403 1.945 12.132 1.296 3.73 3.115 6.979 5.457 9.744 2.343 2.764 5.098 4.924 8.27 6.475 3.169 1.552 6.663 2.328 10.483 2.328h10.377l11.412 13.327h-22.114zm58.15 1.636c-5.983 0-11.404-1.195-16.267-3.584a36.827 36.827 0 0 1-12.43-9.87c-3.423-4.19-6.072-9.052-7.944-14.584-1.876-5.533-2.81-11.44-2.81-17.727 0-6.287.937-12.176 2.81-17.665 1.872-5.49 4.521-10.33 7.944-14.522a36.179 36.179 0 0 1 12.43-9.809c4.863-2.345 10.287-3.518 16.267-3.518 5.98 0 11.492 1.176 16.32 3.518 4.826 2.35 8.971 5.617 12.431 9.809 3.46 4.192 6.125 9.032 7.998 14.522 1.872 5.489 2.809 11.378 2.809 17.665 0 6.286-.937 12.194-2.81 17.727-1.875 5.532-4.54 10.395-7.997 14.583-3.46 4.193-7.602 7.482-12.43 9.87-4.829 2.39-10.268 3.585-16.32 3.585zm0-13.327c3.817 0 7.35-.795 10.593-2.39 3.244-1.591 6.071-3.875 8.486-6.85 2.414-2.977 4.268-6.433 5.567-10.374 1.296-3.938 1.944-8.213 1.944-12.824 0-4.611-.648-8.884-1.944-12.825-1.297-3.937-3.153-7.354-5.567-10.246-2.415-2.892-5.242-5.154-8.486-6.789-3.244-1.635-6.773-2.451-10.593-2.451-3.82 0-7.333.816-10.54 2.451-3.206 1.635-6.017 3.897-8.431 6.79-2.415 2.891-4.287 6.308-5.621 10.245-1.334 3.94-1.998 8.257-1.998 12.952s.667 8.862 1.998 12.762c1.334 3.897 3.206 7.336 5.62 10.311 2.415 2.976 5.224 5.26 8.433 6.852 3.206 1.591 6.717 2.389 10.54 2.389zm35.417 11.692 10.737-13.2h37.506c2.089 0 3.908-.587 5.458-1.76 1.547-1.173 2.774-2.702 3.676-4.589a13.71 13.71 0 0 0 1.35-5.973c0-2.262-.432-4.316-1.297-6.163-.864-1.843-2.072-3.31-3.622-4.4-1.55-1.089-3.335-1.635-5.351-1.635h-13.511c-4.253 0-8.054-1.027-11.404-3.081-3.35-2.051-6-4.924-7.944-8.614C353.975 56.79 353 52.43 353 47.4c0-5.03.937-9.448 2.81-13.265 1.872-3.813 4.43-6.807 7.674-8.989 3.244-2.178 6.917-3.27 11.025-3.27h32.534v13.203h-31.347a8.483 8.483 0 0 0-5.079 1.635c-1.513 1.09-2.686 2.513-3.513 4.276-.83 1.76-1.243 3.646-1.243 5.656 0 2.011.413 4.003 1.243 5.722.827 1.72 1.982 3.103 3.46 4.149 1.475 1.049 3.15 1.57 5.025 1.57h13.834c4.613 0 8.593 1.049 11.943 3.143 3.35 2.098 5.946 4.987 7.781 8.676 1.838 3.69 2.756 7.922 2.756 12.7 0 5.617-.955 10.457-2.865 14.522-1.91 4.068-4.506 7.211-7.781 9.43-3.279 2.222-6.973 3.333-11.079 3.333h-49.862z",
    className: "icos_inline_svg__cls-5",
    style: {
      strokeWidth: 0.287703
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g3",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path2",
    d: "M481.2 237.59h-.13s0 .05.02.07c.27 1.05.42 2.14.42 3.28 0 1.14-.15 2.22-.43 3.26 0 .03 0 .05-.02.08h11.91c.17-1.09.25-2.21.25-3.35 0-1.14-.08-2.26-.23-3.35h-11.78z",
    style: {
      fill: "#6ed3b6",
      opacity: 0.7
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path3",
    d: "M511.78 219.94c-.99-2.01-2.11-3.95-3.36-5.79a48.022 48.022 0 0 0-12.92-12.93 45.37 45.37 0 0 0-5.77-3.35l-3.36 5.81-2.53 4.37-3.35 5.82-2.53 4.37-3.4 5.87-2.51 4.35-.07.1c-1.05-.27-2.16-.42-3.28-.42-1.12 0-2.23.15-3.28.42l-.07-.1-2.51-4.35-3.4-5.87-2.53-4.37-3.35-5.82-2.53-4.37c4.4-2.11 9.22-3.43 14.3-3.83v23.59c1.09-.22 2.21-.32 3.35-.32 1.14 0 2.26.1 3.35.32v-30.3c-1.1-.1-2.23-.13-3.35-.13s-2.24.03-3.35.13c-6.31.42-12.26 2.07-17.67 4.73-2.01.97-3.93 2.09-5.77 3.35l3.35 5.82 2.53 4.35a35.863 35.863 0 0 0-8.62 8.63l-4.37-2.53-5.82-3.35a45.606 45.606 0 0 0-3.35 5.79 47.246 47.246 0 0 0-4.72 17.65c-.1 1.1-.13 2.22-.13 3.35 0 .28.02.57.02.87.35-.02.7-.03 1.05-.03 1.91 0 3.78.12 5.64.32 0-.38-.02-.77-.02-1.15 0-1.12.05-2.24.15-3.35.38-5.09 1.72-9.9 3.81-14.3l4.37 2.53c-1.67 3.65-2.78 7.61-3.16 11.78a36.877 36.877 0 0 0-.1 5.29c1.82.37 3.63.85 5.39 1.41.52.17 1.02.33 1.54.52-.02-.17-.05-.35-.07-.52h11.81c-.2-1.09-.32-2.21-.32-3.35 0-1.14.1-2.26.32-3.35h-11.83c.32-2.96 1.1-5.79 2.26-8.42l4.37 2.53 5.87 3.4c.74-2.14 1.87-4.12 3.35-5.79l-5.87-3.4-4.37-2.53c1.72-2.36 3.81-4.43 6.16-6.17l2.53 4.38 3.38 5.87 2.51 4.33.07.12c-1.54 1.56-2.68 3.5-3.26 5.67-.02.02-.02.05-.03.07a13.044 13.044 0 0 0 0 6.56l-.12.07h.15c.59 2.17 1.74 4.12 3.28 5.64l-.08.15.15-.08c.18.2.37.38.57.55 1.64-.74 3.33-1.37 5.07-1.87l1.61-.42 1.62-.44h.02l.1-.18.35-.6c-.12.02-.23.02-.35.02-.12 0-.23 0-.35-.02-.85-.05-1.67-.27-2.39-.65-.22-.1-.42-.22-.6-.33-.7-.47-1.29-1.05-1.74-1.76-.13-.2-.25-.4-.35-.62-.37-.72-.59-1.52-.64-2.38-.02-.12-.02-.23-.02-.35 0-.12 0-.23.02-.35.05-.85.27-1.66.64-2.38a6.078 6.078 0 0 1 2.09-2.38c.18-.12.38-.23.6-.33.72-.38 1.54-.6 2.39-.65.12-.02.23-.02.35-.02.12 0 .23 0 .35.02.85.05 1.67.27 2.39.65.22.1.42.22.6.33.7.47 1.29 1.05 1.74 1.76.13.2.25.4.35.62l.35-.62 3.28-5.67.07-.12 2.51-4.33c.65.57 1.27 1.19 1.82 1.84 1.47 1.67 2.61 3.65 3.35 5.79l5.87-3.4 4.37-2.53c1.15 2.63 1.94 5.45 2.28 8.42.12 1.1.18 2.21.18 3.35 0 .42-.03.84-.05 1.25 1.24-1.59 2.54-3.13 3.91-4.6.77-.84 1.57-1.64 2.38-2.43-.54-3.28-1.51-6.42-2.86-9.35l4.37-2.53a41.37 41.37 0 0 1 2.83 8.01c1.84-1.51 3.78-2.89 5.79-4.2a47.73 47.73 0 0 0-2.81-7.16zm-13.52.08-5.84 3.36-4.37 2.53a24.533 24.533 0 0 0-4.32-4.32l2.53-4.38 3.36-5.82 2.53-4.37c4.08 2.84 7.63 6.39 10.46 10.47z",
    className: "icos_inline_svg__cls-2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path4",
    d: "M22.672 78.756c-.307 0-.609-.186-.774-.519l-2.47-4.949-2.593 4.62c-.168.302-.456.485-.77.472-.31-.009-.593-.205-.75-.515L9.098 65.413c-.248-.496-.101-1.13.323-1.418.427-.289.973-.121 1.219.375l5.487 10.994 2.593-4.62c.168-.301.45-.49.77-.472.31.01.593.205.75.515l3.199 6.405c.248.496.101 1.13-.323 1.418a.79.79 0 0 1-.448.14z",
    className: "icos_inline_svg__cls-4",
    style: {
      strokeWidth: 0.287703
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path5",
    d: "M32.344 84.999c-.301 0-.595-.177-.763-.497l-3.278-6.243a1.188 1.188 0 0 1-.01-1.061l2.934-5.892-8.555-17.144-5.098 10.212c-.248.496-.792.664-1.22.375-.426-.289-.57-.925-.322-1.418l5.869-11.76c.16-.32.453-.518.77-.518.318 0 .612.198.772.518l9.587 19.21c.16.323.16.72 0 1.043l-2.926 5.88 3 5.718c.257.49.123 1.13-.296 1.428a.802.802 0 0 1-.464.152z",
    className: "icos_inline_svg__cls-4",
    style: {
      strokeWidth: 0.287703
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path6",
    d: "M62.242 66.145H48.147c-.326 0-.627-.208-.784-.54l-2.337-4.99-2.401 4.81c-.16.323-.448.519-.779.516-.32 0-.616-.208-.77-.534l-8.718-18.22-2.505 5.399c-.155.332-.448.54-.771.546-.342.012-.624-.193-.787-.519l-3.527-7.065c-.248-.496-.101-1.133.323-1.418.427-.289.971-.121 1.22.375l2.725 5.462 2.521-5.434c.155-.335.454-.543.78-.546.32-.009.626.202.786.534l8.747 18.282 2.409-4.828a.904.904 0 0 1 .784-.518c.323.006.616.211.771.54l2.844 6.066h13.567c.493 0 .894.466.894 1.04 0 .574-.4 1.04-.894 1.04z",
    className: "icos_inline_svg__cls-4",
    style: {
      strokeWidth: 0.287703
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path7",
    d: "M38.576 84.999c-.31 0-.609-.186-.774-.518l-3.11-6.259a1.183 1.183 0 0 1-.024-.984l2.542-5.908-5.81-12.163c-.24-.5-.086-1.133.347-1.412.432-.28.973-.1 1.213.403L38.997 70.8c.144.3.15.66.019.968l-2.537 5.899 2.868 5.774c.245.497.101 1.133-.326 1.418a.782.782 0 0 1-.445.14z",
    className: "icos_inline_svg__cls-4",
    style: {
      strokeWidth: 0.287703
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path8",
    d: "M25.867 72.348c-.306 0-.608-.186-.773-.518l-3.196-6.405c-.248-.496-.101-1.129.323-1.418.427-.288.97-.12 1.219.376l3.196 6.404c.248.497.101 1.13-.323 1.418a.79.79 0 0 1-.448.14z",
    className: "icos_inline_svg__cls-4",
    style: {
      strokeWidth: 0.287703
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path9",
    d: "M13.08 59.536a.815.815 0 0 1-.45-.14c-.426-.288-.57-.924-.322-1.418l6.394-12.812c.248-.496.795-.664 1.22-.375.426.288.57.925.322 1.418L13.85 59.021c-.165.332-.464.518-.774.518z",
    className: "icos_inline_svg__cls-4",
    style: {
      strokeWidth: 0.287703
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path10",
    d: "M21.012 88.244c-.306 0-.608-.186-.773-.518l-1.62-3.245c-.247-.497-.1-1.13.323-1.418.427-.289.971-.121 1.22.375l1.619 3.246c.248.496.101 1.13-.323 1.418a.79.79 0 0 1-.448.14z",
    className: "icos_inline_svg__cls-4",
    style: {
      strokeWidth: 0.287703
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path11",
    d: "M16.139 68.044c-1.371 0-2.49-1.297-2.49-2.895s1.116-2.895 2.49-2.895 2.489 1.297 2.489 2.895-1.115 2.895-2.49 2.895m0-4.232c-.635 0-1.15.599-1.15 1.337 0 .739.515 1.338 1.15 1.338.635 0 1.15-.6 1.15-1.338 0-.738-.515-1.337-1.15-1.337z",
    className: "icos_inline_svg__cls-5",
    style: {
      strokeWidth: 0.287703
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g12",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle11",
    cx: 161.42,
    cy: 324.99,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path12",
    d: "M161.42 334.32c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g13",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle12",
    cx: 113.46,
    cy: 283.65,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path13",
    d: "M113.46 292.98c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g14",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle13",
    cx: 197.68,
    cy: 345.12,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path14",
    d: "M197.68 354.44c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g15",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle14",
    cx: 221.05,
    cy: 304.32,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path15",
    d: "M221.05 313.65c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g16",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle15",
    cx: 173.41,
    cy: 304.35,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path16",
    d: "M173.41 313.67c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g17",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle16",
    cx: 149.44,
    cy: 345.64,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path17",
    d: "M149.44 354.96c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g18",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle17",
    cx: 197.68,
    cy: 263.58,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path18",
    d: "M197.68 272.91c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g19",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle18",
    cx: 233.64,
    cy: 242.93,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path19",
    d: "M233.64 252.26c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g20",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle19",
    cx: 197.68,
    cy: 221.77,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path20",
    d: "M197.68 231.1c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g21",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle20",
    cx: 233.62,
    cy: 283.7,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path21",
    d: "M233.62 293.03c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g22",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle21",
    cx: 149.44,
    cy: 221.77,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path22",
    d: "M149.44 231.1c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g28",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path23",
    d: "M544.87 222.84c-8.36.45-16.29 2.64-23.4 6.21-2.01.99-3.95 2.09-5.81 3.31a60.789 60.789 0 0 0-17.33 17.05 59.307 59.307 0 0 0-3.41 5.76 59.703 59.703 0 0 0-6.59 23.56c-.08 1.34-.13 2.69-.13 4.05 0 .89.02 1.77.07 2.64h6.69c-.05-.87-.07-1.76-.07-2.64a52.766 52.766 0 0 1 5.85-24.24c1-2.01 2.16-3.93 3.41-5.77 3.95-5.79 9-10.74 14.86-14.59l2.53 4.37 3.35 5.81 2.53 4.37a35.717 35.717 0 0 0-8.7 8.47l-4.37-2.53-5.82-3.36a43.315 43.315 0 0 0-3.43 5.76l5.81 3.35 4.35 2.51a36.558 36.558 0 0 0-3.41 11.83c-.13 1.32-.22 2.68-.22 4.05 0 .89.03 1.77.1 2.64.3 4.28 1.36 8.38 3.03 12.13l-4.37 2.51c-2.09-4.5-3.36-9.45-3.7-14.64a41.76 41.76 0 0 1 .12-6.69h-6.71c-.13 1.34-.18 2.68-.18 4.05 0 .89.02 1.77.08 2.64.33 6.41 1.94 12.5 4.57 18l-4.37 2.53-5.81 3.35c.99 2.01 2.09 3.95 3.3 5.82l5.81-3.35 4.35-2.51c3.46 5.27 7.93 9.82 13.12 13.37l-2.53 4.37-3.35 5.81c1.86 1.24 3.76 2.36 5.76 3.4l3.36-5.82 2.51-4.35a47.6 47.6 0 0 0 18.17 4.94v11.74c1.1.07 2.23.1 3.35.1s2.24-.03 3.35-.1v-35.27a24.58 24.58 0 0 1-6.7 0v16.81a40.78 40.78 0 0 1-14.82-4.03l2.53-4.37 3.35-5.81 2.53-4.38 3.38-5.84c-2.12-.8-4.07-1.99-5.72-3.46l-3.4 5.87-2.53 4.4-3.36 5.81-2.51 4.37c-4.2-2.93-7.83-6.64-10.67-10.91l4.37-2.51 5.79-3.35 4.38-2.53a24.583 24.583 0 0 1-3.21-5.87l-4.4 2.54a29.512 29.512 0 0 1-2.14-8.77h11.79a18.086 18.086 0 0 1 .25-6.69h-11.88c.38-2.98 1.24-5.82 2.46-8.47.94-2.04 2.11-3.96 3.48-5.72 1.77-2.31 3.86-4.33 6.22-6.04l2.53 4.38c-1.62 1.2-3.08 2.61-4.37 4.18a23.982 23.982 0 0 0-3.48 5.72l5.84 3.36c.82-2.11 2.02-4.03 3.55-5.67.57-.64 1.19-1.22 1.84-1.76 1.72-1.42 3.7-2.53 5.86-3.23l-3.4-5.89-2.54-4.38-3.36-5.82-2.51-4.37-3.38-5.82-2.51-4.35c6.12-3.01 12.9-4.87 20.06-5.32v5.05c1.1-.1 2.23-.13 3.35-.13s2.24.03 3.35.13v-11.74c-1.1-.07-2.23-.1-3.35-.1s-2.24.03-3.35.1z",
    className: "icos_inline_svg__cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path24",
    d: "M544.87 241.29v11.74c1.1-.12 2.21-.18 3.35-.18 1.14 0 2.24.07 3.35.18v-11.74a37.206 37.206 0 0 0-6.7 0",
    className: "icos_inline_svg__cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path25",
    d: "M544.87 258.11v6.78c1.09-.22 2.21-.32 3.35-.32 1.14 0 2.26.1 3.35.32v-6.78a24.58 24.58 0 0 0-6.7 0",
    className: "icos_inline_svg__cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path26",
    d: "m566.25 306.62-2.53-4.4-3.4-5.87c-1.66 1.47-3.6 2.66-5.72 3.46l3.38 5.84 2.53 4.38 3.35 5.81 2.53 4.37a38.58 38.58 0 0 0 5.74-3.41l-2.51-4.37-3.36-5.81z",
    className: "icos_inline_svg__cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path27",
    d: "m575.87 294.18-4.4-2.54c-.8 2.11-1.89 4.08-3.21 5.87l4.38 2.53 5.79 3.35 4.37 2.51a38.74 38.74 0 0 0 3.26-5.84l-4.37-2.51-5.82-3.36z",
    className: "icos_inline_svg__cls-2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path28",
    d: "M608.11 278.72a59.75 59.75 0 0 0-6.59-23.56c-1.04-1.99-2.17-3.9-3.41-5.76a60.917 60.917 0 0 0-17.33-17.05c-1.86-1.22-3.8-2.33-5.81-3.31l-3.35 5.81-2.51 4.35-3.38 5.82-2.51 4.37-3.36 5.82c2.07.87 4.02 1.97 5.82 3.28 2.36 1.71 4.45 3.73 6.22 6.04l-4.38 2.53c1.41 1.72 2.59 3.65 3.48 5.72l4.38-2.53a29.24 29.24 0 0 1 2.46 8.47h-5.07c.22 1.32.33 2.68.33 4.05 0 .89-.05 1.77-.15 2.64h28.52a52.826 52.826 0 0 1-5.24 20.53l-4.37-2.53c-.95 2.02-2.06 3.98-3.28 5.84l4.35 2.51 5.81 3.35a59.32 59.32 0 0 0 3.3-5.82c3.6-7.26 5.76-15.32 6.12-23.87.05-.87.07-1.76.07-2.64 0-1.36-.05-2.71-.13-4.05zm-30.68-40.55a53.61 53.61 0 0 1 14.86 14.59l-4.37 2.53a48.016 48.016 0 0 0-13.02-12.75zm-8.4 14.54 2.53-4.37c4.1 2.78 7.68 6.27 10.54 10.31l-4.37 2.53c-2.39-3.3-5.34-6.16-8.7-8.47zm15.58 26.01c-.47-4.2-1.66-8.18-3.41-11.83l4.35-2.51 5.81-3.35 4.35-2.51a52.817 52.817 0 0 1 5.7 20.19h-16.8z",
    className: "icos_inline_svg__cls-2"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path29",
    d: "m97.574 55.018-.445.897-.446.903a9.615 9.615 0 0 0-3.761-1.173v11.199a1.39 1.39 0 0 0-.73-.326 1.43 1.43 0 0 0-.161-.01c-.053 0-.107.007-.16.01a1.392 1.392 0 0 0-.731.326V53.569a9.516 9.516 0 0 1 1.785 0c.021 0 .045.006.066.006 1.58.134 3.103.608 4.53 1.406.019.009.04.021.059.037z",
    className: "icos_inline_svg__cls-2",
    style: {
      strokeWidth: 0.287703
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path30",
    d: "m91.212 71.982-.075.155v-.183c.027.009.048.022.075.025z",
    className: "icos_inline_svg__cls-2",
    style: {
      strokeWidth: 0.287703
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path31",
    d: "M88.854 69.304h-.158l.134-.087c.005.031.013.056.021.087z",
    className: "icos_inline_svg__cls-2",
    style: {
      strokeWidth: 0.287703
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path32",
    d: "M88.854 69.304h-.158l.134-.087c.005.031.013.056.021.087z",
    className: "icos_inline_svg__cls-2",
    style: {
      strokeWidth: 0.287703
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path33",
    d: "m89.729 71.005-.139.093.08-.162a.194.194 0 0 0 .059.069z",
    className: "icos_inline_svg__cls-2",
    style: {
      strokeWidth: 0.287703
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path34",
    d: "m89.729 71.005-.139.093.08-.162a.194.194 0 0 0 .059.069z",
    className: "icos_inline_svg__cls-2",
    style: {
      strokeWidth: 0.287703
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path35",
    d: "m91.212 71.982-.075.155v-.183c.027.009.048.022.075.025z",
    className: "icos_inline_svg__cls-2",
    style: {
      strokeWidth: 0.287703
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__rect35",
    d: "M74.068 68.165h7.194v1.241h-7.194z",
    className: "icos_inline_svg__cls-2",
    style: {
      strokeWidth: 0.287703
    }
  }), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g36",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle35",
    cx: 468.72,
    cy: 240.93,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path36",
    d: "M468.72 250.26c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g37",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle36",
    cx: 481.05,
    cy: 318.5,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path37",
    d: "M481.05 327.82c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g38",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle37",
    cx: 476.92,
    cy: 267.63,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path38",
    d: "M476.92 276.96c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g39",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle38",
    cx: 441.34,
    cy: 224.79,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path39",
    d: "M441.34 234.12c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g40",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle39",
    cx: 468.72,
    cy: 208.93,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path40",
    d: "M468.72 218.26c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g41",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle40",
    cx: 513.05,
    cy: 260.82,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path41",
    d: "M513.05 270.14c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g42",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle41",
    cx: 535.69,
    cy: 301.46,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path42",
    d: "M535.69 310.79c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g43",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle42",
    cx: 568.56,
    cy: 318.29,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path43",
    d: "M568.56 327.62c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g44",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle43",
    cx: 586.06,
    cy: 261.38,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path44",
    d: "M586.06 270.71c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g45",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle44",
    cx: 548.21,
    cy: 242.53,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path45",
    d: "M548.21 251.86c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path46",
    d: "M45.591 31.172h-4.663c7.275-8.204 17.185-13.262 28.095-13.262 9.38 0 18.022 3.74 24.886 10.004-2.761 1.663-5.205 3.962-7.176 6.749-5.05-4.015-11.148-6.367-17.712-6.367-7.814 0-14.965 3.338-20.471 8.84l-2.959-5.96zM92.004 95c-1.539 0-3.043-.18-4.5-.519-5.194 4.4-11.58 7.007-18.483 7.007-7.814 0-14.965-3.339-20.471-8.84l-2.959 5.96h-4.663c7.275 8.204 17.185 13.262 28.095 13.262 13.402 0 25.297-7.633 32.649-19.356C98.657 94.137 95.352 95 92.007 95zm-22.98-84.618c12.406 0 23.7 5.642 32.093 14.83a20.084 20.084 0 0 1 3.387-.295c3.61 0 7.086.977 10.201 2.767C104.605 10.956 87.896 0 69.025 0c-20.15 0-37.841 12.496-47.644 31.172h10.854c8.59-12.654 21.89-20.79 36.794-20.79zm42.902 79.758c-.513.15-1.03.264-1.553.367-7.896 17.174-23.47 28.888-41.35 28.888-14.903 0-28.204-8.136-36.793-20.79H21.375c9.806 18.677 27.495 31.172 47.646 31.172 21.828 0 40.765-14.661 49.923-35.96a24.898 24.898 0 0 1-7.021-3.677z",
    className: "icos_inline_svg__cls-2",
    style: {
      strokeWidth: 0.287703
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path47",
    d: "M69.023 0c18.87 0 35.58 10.956 45.68 27.684-3.116-1.79-6.59-2.767-10.201-2.767-1.15 0-2.278.102-3.388.294-8.392-9.187-19.687-14.829-32.093-14.829V0ZM93.91 27.91c-6.864-6.264-15.507-10.003-24.886-10.003V28.29c6.565 0 12.663 2.353 17.713 6.368 1.971-2.787 4.412-5.086 7.176-6.75zm-1.902 67.086c-1.54 0-3.044-.18-4.5-.518-5.194 4.4-11.58 7.007-18.484 7.007v10.382c13.402 0 25.297-7.633 32.649-19.356-3.015 1.623-6.32 2.485-9.665 2.485zm19.919-4.856c-.513.15-1.03.264-1.553.367-7.896 17.174-23.47 28.888-41.35 28.888v10.382c21.829 0 40.766-14.661 49.924-35.96a24.898 24.898 0 0 1-7.021-3.677z",
    className: "icos_inline_svg__cls-4",
    style: {
      strokeWidth: 0.287703
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path48",
    d: "M43.287 93.96H14.429L0 64.89l14.429-29.072h28.858l9.003 18.137c3.369-6.997 9.715-11.388 16.733-11.388 5.322 0 10.284 2.498 13.896 6.929a17.181 17.181 0 0 1 3.36-1.72c1.575-10.19 9.153-17.667 18.22-17.667 6.354 0 12.148 3.714 15.544 9.833a18.874 18.874 0 0 1 8.8-.816c10.364 1.465 18.404 11.335 19.113 23.464.42 7.137-1.65 13.936-5.83 19.14-4.122 5.132-9.948 8.076-15.985 8.076-4.892 0-9.614-1.902-13.447-5.383a13.98 13.98 0 0 1-9.254.782c-3.254 2.978-7.272 4.601-11.438 4.601-4.813 0-9.38-2.156-12.813-5.988-3.043 2.227-6.522 3.391-10.171 3.391-7.021 0-13.365-4.394-16.734-11.388l-9.003 18.137zM17.006 88.77H40.71l8.821-17.774c.63-1.272 1.806-2.001 3.065-1.905 1.257.096 2.334.993 2.815 2.343 2.288 6.429 7.632 10.584 13.612 10.584 3.332 0 6.477-1.266 9.094-3.662l1.705-1.557 1.39 1.936c2.683 3.739 6.618 5.883 10.795 5.883 3.476 0 6.813-1.49 9.398-4.192l.939-.984 1.208.432c1.102.39 2.249.592 3.407.592 1.798 0 3.523-.465 5.127-1.387l1.352-.775 1.123 1.17c3.193 3.32 7.307 5.147 11.588 5.147 4.874 0 9.393-2.284 12.722-6.43 3.326-4.141 4.975-9.553 4.641-15.24-.565-9.65-6.96-17.501-15.2-18.668-2.915-.413-5.767 0-8.472 1.223l-1.883.853-.915-2.095c-2.414-5.526-7.218-8.958-12.538-8.958-7.28 0-13.295 6.349-13.99 14.767l-.156 1.856-1.56.425c-1.803.49-3.49 1.384-5.007 2.659l-1.758 1.474-1.318-2.002c-2.817-4.27-7.077-6.717-11.692-6.717-5.98 0-11.324 4.154-13.612 10.584-.48 1.35-1.558 2.246-2.815 2.342-1.259.097-2.435-.633-3.067-1.905l-8.822-17.77H17.003L5.151 64.898l11.852 23.88Z",
    className: "icos_inline_svg__cls-5",
    style: {
      strokeWidth: 0.287703
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path49",
    d: "M69.023 56.064h-4.38l-4.38 8.825 4.38 8.824h4.38c4.191 0 7.587-3.95 7.587-8.824 0-4.875-3.396-8.825-7.587-8.825zm3.53 11.053c-.033.068-.062.13-.1.198l-1.112 2.247h-2.32c-1.454 0-2.732-.903-3.434-2.247-.034-.068-.066-.13-.098-.198a5.228 5.228 0 0 1-.486-2.228 5.228 5.228 0 0 1 .584-2.427c.702-1.343 1.977-2.246 3.434-2.246h2.32l1.113 2.246c.034.068.066.13.098.199l1.107 2.228z",
    className: "icos_inline_svg__cls-4",
    style: {
      strokeWidth: 0.287703
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path50",
    d: "M69.023 56.064v4.152h2.321l1.112 2.246c.035.068.067.13.1.199l1.106 2.228-1.107 2.228c-.032.068-.061.13-.099.198l-1.112 2.247h-2.32v4.151c4.19 0 7.586-3.95 7.586-8.824 0-4.875-3.396-8.825-7.587-8.825z",
    className: "icos_inline_svg__cls-2",
    style: {
      strokeWidth: 0.287703
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path51",
    d: "M104.662 67.225h-3.132a12.347 12.347 0 0 0-.824-3.593l1.166-.779.776-.524.77-.518a14.349 14.349 0 0 0-.893-1.797l-.77.518-.777.518-1.168.788a10.275 10.275 0 0 0-2.26-2.628l.678-1.359.445-.903.446-.897a12.412 12.412 0 0 0-1.545-1.039l-.445.897-.446.903-.675 1.356-.45.903-.451.903-.675 1.359-.451.909-.456.912c.576.23 1.099.587 1.544 1.043l.456-.919.451-.909.675-1.359a8.59 8.59 0 0 1 1.606 1.868l-1.168.785-.782.524-.79.531a5.54 5.54 0 0 1 .897 1.797c.066.23.12.468.165.707.053.338.086.686.086 1.04 0 .353-.032.7-.086 1.039h6.298a14.168 14.168 0 0 1-1.008 4.375l-1.166-.785-1.552-1.049-1.169-.785-.781-.524-.785-.53-1.056-.708-.133-.087v-.006l-.817-.546-.594-.4-.28-.187c.004.062.007.124.007.187 0 .062-.005.124-.008.186a2.056 2.056 0 0 1-.12.524 2.222 2.222 0 0 1-.16.326 1.777 1.777 0 0 1-.33.385 1.39 1.39 0 0 1-.73.326 1.43 1.43 0 0 1-.161.008c-.054 0-.107-.006-.16-.009a1.392 1.392 0 0 1-.731-.325 1.777 1.777 0 0 1-.331-.385 2.376 2.376 0 0 1-.16-.326 2.052 2.052 0 0 1-.12-.524l-.28-.186-.595.4-.816.546v.006c.005.03.013.056.02.087h-.157l-1.056.707a7.684 7.684 0 0 1-.165-.707 6.676 6.676 0 0 1-.086-1.04c0-.353.032-.7.086-1.04.045-.238.098-.477.165-.707.197-.67.504-1.278.896-1.796l-.79-.53-.78-.525-1.17-.785a8.59 8.59 0 0 1 1.607-1.868l.675 1.359.45.909.457.918a4.443 4.443 0 0 1 1.544-1.042l-.456-.912-.45-.91-.676-1.359-.45-.903-.451-.903-.67-1.356-.45-.902-.446-.897c-.526.291-1.043.642-1.545 1.04a.312.312 0 0 0-.059.04 13.78 13.78 0 0 0-3.31 3.85.407.407 0 0 0-.035.069 14.88 14.88 0 0 0-.885 1.778l4.26 2.889 1.168.785a8.09 8.09 0 0 0-.405 1.759h-6.274c-.022.37-.035.71-.035 1.04 0 .328.013.67.035 1.039h6.274c.072.611.21 1.204.405 1.76l-1.168.784-1.553 1.05-1.165.778-.777.524-.77.519c.253.61.552 1.213.893 1.796a.407.407 0 0 0 .035.068c.893 1.52 2.008 2.815 3.31 3.851.019.016.04.031.059.04a12.13 12.13 0 0 0 1.544 1.04c.02.015.04.025.06.037 1.426.8 2.95 1.272 4.529 1.406.02 0 .045.006.066.006.307.025.608.04.894.04.285 0 .584-.015.894-.04.02 0 .045-.006.066-.006a11.116 11.116 0 0 0 4.586-1.443 11.464 11.464 0 0 0 1.544-1.04l-.445-.896-.446-.903-.677-1.36a10.276 10.276 0 0 0 2.26-2.627l1.168.788.776.518.77.518c.34-.58.644-1.188.894-1.797.014-.021.022-.046.032-.068a16.384 16.384 0 0 0 1.209-5.269c0-.025.005-.052.005-.077.021-.357.035-.708.035-1.04 0-.332-.014-.68-.035-1.04zm-6.274 0a8.247 8.247 0 0 0-.406-1.76l1.169-.784a9.91 9.91 0 0 1 .584 2.544zM84.25 61.842l-1.169-.789a11.778 11.778 0 0 1 2.75-3.199l.678 1.36a10.275 10.275 0 0 0-2.26 2.628m2.26 15.468-.678 1.359a11.778 11.778 0 0 1-2.75-3.2l1.168-.787.77-.519.777-.524 1.168-.785.782-.525.79-.53 1.053-.708.08-.16a.194.194 0 0 0 .059.067l-.139.093-.608 1.226-.456.919-.451.909-.675 1.359-.45.903-.446.897zm4.627-5.176v8.747a9.615 9.615 0 0 1-3.761-1.173l.675-1.356.45-.903.452-.903.674-1.359.451-.909.456-.912.609-1.229v-.183c.026.009.048.022.074.025l-.074.155zm1.785 8.747v-8.747l.608 1.229.456.912.451.91.675 1.358.45.903.452.903.67 1.356a9.576 9.576 0 0 1-3.76 1.173zm3.732-5.374-.675-1.36-.45-.908-.457-.919-.608-1.225 1.053.707.79.53.782.525 1.168.785a8.59 8.59 0 0 1-1.606 1.868z",
    className: "icos_inline_svg__cls-2",
    style: {
      strokeWidth: 0.287703
    }
  }), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g52",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle51",
    cx: 420.8,
    cy: 294.74,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path52",
    d: "M420.81 304.07c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g53",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle52",
    cx: 456.52,
    cy: 314.83,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path53",
    d: "M456.52 324.16c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    id: "icos_inline_svg__g54",
    transform: "matrix(.26676 0 0 .3103 -20.39 -23.126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "icos_inline_svg__circle53",
    cx: 444.16,
    cy: 257.35,
    r: 6.82,
    className: "icos_inline_svg__cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "icos_inline_svg__path54",
    d: "M444.16 266.68c-5.14 0-9.33-4.18-9.33-9.33s4.18-9.33 9.33-9.33 9.33 4.18 9.33 9.33-4.18 9.33-9.33 9.33m0-13.64a4.31 4.31 0 1 0 0 8.62 4.31 4.31 0 0 0 0-8.62",
    className: "icos_inline_svg__cls-5"
  }))));
};
export default SvgIcosinline;